import React, { useState, useEffect } from 'react';
import { FormControlLabel, RadioGroup, Radio, Button } from "@material-ui/core";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import baseUrl from '../../config/config';
import '../../../styles/content.scss';
import { makeStyles } from '@material-ui/styles';

export default function Condition(props) {
    function StyledRadio(props) {
        const useStyles = makeStyles({
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                },
            }
        })
        const classes = useStyles();

        return (
            <Radio
                className={classes.root}
                disableripple="true"
                color="default"
                checkedIcon={<CheckCircleIcon className="checkedIcon" />}
                icon={<RadioButtonUncheckedIcon />}
                {...props}
            />
        );
    }

    const handleHomePageChange = ()=>{
        props.handlePageChange(1)
        props.showCaptcha(false);
    }

    return (
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0 mb-4">
                    How would you rate the overall condition of the property?
                </h4>
                <span className="montserrat-medium py-2">Please consider both the interior and the exterior of the house and pick the option that best applies.</span>

                <div className="pt-2 form-content-field">
                    <div>
                        <RadioGroup className='condition-label' name="property_overall_condition_id" value={props.values.property_overall_condition_id} onChange={props.handleChange} >
                            {props.condition && props.condition.map((condition, index) => (
                                <FormControlLabel
                                    key={condition.property_overall_condition_id}
                                    label={condition.condition}
                                    control={<StyledRadio />}
                                    value={condition.property_overall_condition_id.toString()}
                                />
                            ))}
                        </RadioGroup>
                    </div>
                    {props.validateDisplay5 === true ?
                        props.errors.property_overall_condition ?
                            <div className="error-msg">{props.errors.property_overall_condition}</div> : ''
                        : ''}
                </div>
                <div className="form-content-field">
                    <div className="py-2 row">
                        <div className="py-5 col-md-auto" style={{ marginBottom:"50px" }}>
                            <Button className="form-button-primary" onClick={handleHomePageChange}>
                                Back 
                            </Button>
                            <Button className="form-button-primary home-section-next" onClick={() => props.handlePageChange(3)} >
                                Next 
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
